import React, {Component} from 'react';
import {API_URL} from "../../settings/local_settings";
import {APIClient} from "../../utils/APIClient";
import {YesNoModal} from "../elements/YesNoModal";

export class DeleteSyncConfigurationModal extends Component {
    constructor(props) {
        super(props);

        this.handleDelete = this.handleDelete.bind(this);
    }

    handleDelete () {
        new APIClient(API_URL + `node-to-gsheet/sync-configuration/${this.props.syncConfigurationId}/delete`).call('GET').then((data) => {
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            }

            this.props.onRemoveSyncConfiguration(this.props.syncConfigurationId);
        })
    }

    render() {
        return <YesNoModal onYesAnswer={this.handleDelete}
                           title="Estas a punto de eliminar la sincronización de una planilla"
                           message="Al confirmar esta operación se dejará de exportar automáticamente la información a la planilla."
                           question="¿Estás seguro que querés continuar?"
                           buttonClassName={""}
                           buttonText={""}
                           buttonIconName={"trash"}
        />
    }
}

